<!--
 * @Author: shao
 * @Date: 2023-10-19 13:44:24
 * @LastEditors: [you name]
 * @LastEditTime: 2023-10-19 13:45:44
 * @Description: 
-->
<template>
  <div class="page">
   <img src="../assets/business-cert.jpg"/>
  </div>
</template>

<script>
export default {
  name: "busnisessCert",
  data() {
    return {
     
           
      
      
    };
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style scoped>
.page {
  display: block;
  width: 6.9rem;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  /* padding-right: 0.3rem;
  padding-left: 0.3rem; */
}
img{
  width: 100%;
  height:auto;
}

</style>


// WEBPACK FOOTER //
// src/components/busnisessCert.vue